import { FC, useEffect } from "react";
import "../CSS/CalendarDetailScreen.css";
import backIcon from "../../../assets/images/back-icon.svg";
import locationIcon from "../../../assets/images/location-icon.svg";
import starIcon from "../../../assets/images/communicate-star-icon.svg";
import creativeImage from "../../../assets/images/execution-creative-space.png";
import innovateImage from "../../../assets/images/execution-innovate-space.png";
import { useLocation, useNavigate } from "react-router-dom";
import ImageCarousel from "components/elements/ImageCarousel";
import { CALENDAR_RESERVATION_TYPE, MENU_ITEM } from "utils/constants";
import { useTabBar } from "services/TabBarProvider";
import { IMAGE_LINK, WEB_LINK } from "utils/strings";
import { useLogout } from "services/LogoutProvider";
import ROUTE_PATHS from "utils/routePaths";
import { trackDetailView } from "utils/analytics";

interface Benefits {
  title: string;
  buttonTitle: string;
  image: string;
}

const CreativeSpaceDetailScreen: FC = () => {
  const memberBenefits: Benefits[] = [
    {
      title: "Creative Space",
      buttonTitle: "Explore",
      image: creativeImage,
    },
    {
      title: "Innovate Space",
      buttonTitle: "Explore",
      image: innovateImage,
    },
    {
      title: "Communicate Space",
      buttonTitle: "Explore",
      image: creativeImage,
    },
  ];

  const navigate = useNavigate();
  const location = useLocation();
  const { handleAppExit } = useLogout();
  const { setSelectedTabBar } = useTabBar();

  useEffect(() => {
    trackDetailView("creative_space", "CREATIVE_SPACE");
  }, []);

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const handleReserveClick = () => {
    const fromPath = (location.state as { from?: string } | null)?.from;
    if (
      fromPath === ROUTE_PATHS.WSM_UR_MEMBERSHIP_PLAN_DETAIL ||
      fromPath === ROUTE_PATHS.WSM_MEMBERSHIP_PLAN_DETAIL
    ) {
      navigate(-2);
    } else {
      navigate(-1);
    }
    sessionStorage.setItem(
      "calendarSelectedTab",
      CALENDAR_RESERVATION_TYPE.DF_WORKSPACE,
    );
    setSelectedTabBar(MENU_ITEM.CALENDAR);
  };

  const openWorkspaceLocation = () => {
    handleAppExit(WEB_LINK.SABE_LOCATION);
  };

  const handleMemberBenefitsChange = (index: number) => {
    if (index === 0) {
      sessionStorage.setItem(
        "calendarSelectedTab",
        CALENDAR_RESERVATION_TYPE.DF_WORKSPACE,
      );
      setSelectedTabBar(MENU_ITEM.CALENDAR);
    } else if (index === 1) {
      sessionStorage.setItem(
        "calendarSelectedTab",
        CALENDAR_RESERVATION_TYPE.INNOVATE_SPACE,
      );
      setSelectedTabBar(MENU_ITEM.CALENDAR);
    } else if (index === 2) {
      sessionStorage.setItem(
        "calendarSelectedTab",
        CALENDAR_RESERVATION_TYPE.MEETING_ROOMS,
      );
      setSelectedTabBar(MENU_ITEM.CALENDAR);
    }
    navigate(-1);
  };

  return (
    <div className="wms-mobile-container">
      <div className="calendar_detail-screen-container">
        <div className="calendar_detail-header-container">
          <img
            src={backIcon}
            alt="dropdown-logo"
            className="image"
            onClick={handleBackButtonClick}
          />
          <span>
            Execution <span style={{ color: "#ff6b35" }}>Space</span>
          </span>
        </div>
        <div
          className="calendar-detail-banner-image-container"
          style={{ backgroundImage: `url(${IMAGE_LINK.CREATIVE_SPACE})` }}
        ></div>
        <div className="calendar_detail-date-location-container">
          <div className="detail-container">
            <div className="image">
              <img src={locationIcon} alt="location-logo" />
            </div>
            <div className="right-container">
              <div className="sub-container">
                <span>SabeHub, Mohali</span>
                <span className="sub-text">SCO-4, 2nd Floor, Sec-68</span>
              </div>
              <button onClick={openWorkspaceLocation}>Direction</button>
            </div>
          </div>
        </div>
        <div className="calendar_detail-container">
          <span>
            About <span style={{ color: "#ff6b35" }}>Execution Space</span>
          </span>
          <div className="divider"></div>
          <div className="communicate_space_container ">
            <span style={{ color: "#ff6b35" }}>Description</span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Create Space is built for
              the work that starts in your mind.
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Use it when you need to
              think, read, write, plan, reflect, or shape an idea before the day
              gets loud.
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> With low lounge-style
              seating, a library-inspired environment, and a calmer pace, Create
              Space helps you move out of reaction mode and return to original
              thinking.
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Come here when you need
              clarity before action.
            </span>
            <span style={{ marginTop: "10px", color: "#ff6b35" }}>
              Key Benefits
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Turn scattered thoughts
              into clear direction
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Give your best ideas space
              to surface before calls, messages, and execution take over
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Leave with sharper
              priorities, better thinking, and a calmer start to your workday
            </span>
            <span style={{ marginTop: "10px", color: "#ff6b35" }}>
              Features
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Low lounge-style seating
              designed for slower, deeper thinking
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Library-inspired setting
              for reading, writing, planning, and reflection
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Quiet, warm environment
              that feels calm and intentional
            </span>
          </div>
        </div>
        <div className="calendar_detail-member-benefits-container">
          {memberBenefits.map((benefits, index) => (
            <div key={index}>
              <div className="divider"></div>
              <div
                key={index}
                className="dashboard-screen-member-benefits-list-item"
                style={{
                  backgroundImage: `url(${benefits.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
                onClick={() => handleMemberBenefitsChange(index)}
              >
                <div
                  className={`dashboard-screen-member-benefits-list-sub-item ${
                    index % 2 === 0 ? "odd-card" : "even-card"
                  }`}
                >
                  <div className="title">{benefits.title}</div>
                  <div className="btn-container">
                    <button>{benefits.buttonTitle}</button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="calendar_detail-contact-detail-container">
          <ImageCarousel
            images={[IMAGE_LINK.CREATIVE_SPACE_1, IMAGE_LINK.CREATIVE_SPACE_2]}
            title="In Real"
            subTitle="Life"
          />
        </div>
        <button
          className="calendar_detail-reserve-btn"
          onClick={handleReserveClick}
        >
          Reserve Now
        </button>
      </div>
    </div>
  );
};

export default CreativeSpaceDetailScreen;
